import { ProgressRange, ProgressRoot, ProgressTrack } from '@chakra-ui/react'

import { PERCENT_SCALE } from 'utils/units'

interface ProgressBarProperties {
  className?: string
  max?: number
  value: number
}
export const ProgressBar = ({ className, max = PERCENT_SCALE, value }: ProgressBarProperties) => {
  /* --- Section 3: Derived Values --- */
  const progressValue = Math.max(0, Math.min(max, value))

  /* --- Section 6: Render --- */
  return (
    <ProgressRoot className={className} max={max} value={progressValue}>
      <ProgressTrack bg="var(--theme-accent-border)" borderRadius="md" h="[10px]" overflow="hidden">
        <ProgressRange bg="var(--coach-accent)" borderRadius="md" />
      </ProgressTrack>
    </ProgressRoot>
  )
}
